import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from "@mui/material";

const RemoveDialog = ({ open, close, user, event }) => {
  return (
    <Dialog open={open} onClose={() => close("cancel")}>
      <DialogTitle id="alert-dialog-title">Confirm Removal</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Are you sure you want to remove {user?.profile?.firstName} from {event?.name}?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => close("cancel")}>Cancel</Button>
        <Button onClick={() => close("confirm")} autoFocus>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RemoveDialog;
